import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import apiClient from '../services/apiClient';
import {
  AgeGateRefusal,
  BirthDateField,
  isAgeGateBlocked,
  isAgeRefusal,
  markAgeGateBlocked,
} from '../components/AgeGate';

export default function RegisterPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  // 999.18844 — neutral date-of-birth field; an under-13 refusal hides the form
  // and the short-lived flag keeps it hidden on a back-button retry.
  const [birthDate, setBirthDate] = useState('');
  const [ageRefused, setAgeRefused] = useState(() => isAgeGateBlocked());
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      // Posted directly: AuthContext.register (a hub) only carries the four
      // original fields.
      await apiClient.post('/api/auth/register', { email, password, confirmPassword, name, birthDate });
      setSuccess('Registration successful! Please check your email to verify your account.');
    } catch (err) {
      if (isAgeRefusal(err)) {
        markAgeGateBlocked();
        setAgeRefused(true);
        return;
      }
      setError(err.data?.message || err.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Create Account</h1>
        <p className="subtitle">Join Raike & Sons</p>

        {error && <div className="error-message" role="alert" aria-live="assertive">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        {ageRefused && <AgeGateRefusal />}

        {!success && !ageRefused && (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="register-name">Full Name</label>
              <input id="register-name" type="text" value={name} onChange={e => setName(e.target.value)} required autoFocus autoComplete="name" />
            </div>
            <div className="form-group">
              <label htmlFor="register-email">Email</label>
              <input id="register-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" />
            </div>
            <div className="form-group">
              <label htmlFor="register-password">Password</label>
              <input id="register-password" type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={8} autoComplete="new-password" />
            </div>
            <div className="form-group">
              <label htmlFor="register-confirm-password">Confirm Password</label>
              <input id="register-confirm-password" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required autoComplete="new-password" />
            </div>
            <BirthDateField id="register-birth-date" value={birthDate} onChange={setBirthDate} />
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Creating account...' : 'Create Account'}
            </button>
          </form>
        )}

        <div className="auth-links">
          <Link to={`/login${redirectUrl ? `?redirect=${encodeURIComponent(redirectUrl)}` : ''}`}>
            Already have an account? Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
